/**
 * 通用格式化工具（双端共用）
 */
/** 公历时间：yyyy-MM-dd HH:mm:ss（默认本地时区） */
export function formatDateTime(value, opts = {}) {
    const d = typeof value === 'string' || typeof value === 'number' ? new Date(value) : value;
    if (Number.isNaN(d.getTime()))
        return String(value);
    const pad = (n) => String(n).padStart(2, '0');
    const base = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    return (opts.seconds ?? true) ? `${base}:${pad(d.getSeconds())}` : base;
}
//# sourceMappingURL=format.js.map